import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {CreateRequestHelperObject} from '../../model/CreateRequestHelperObject';
import {RequestConfirmationHelperObject} from '../../model/RequestConfirmationHelperObject';
import {Location} from '@angular/common';
import {TopLevelDomainVO} from '../../generate/TopLevelDomainVO';
import {RequestMetadata} from '../../generate/RequestMetadata';
import {ChangeVO} from '../../generate/ChangeVO';
import {CommonStrings} from '../../model/CommonStrings';
import {DomainService} from '../../services/domain.service';

@Component({
  selector: 'create-request',
  templateUrl: './create-request.component.html',
  styleUrls: ['./create-request.component.scss']
})
export class CreateRequestComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  domain: TopLevelDomainVO;

  @Input()
  requestMetadata: RequestMetadata;

  domainChange: ChangeVO;

  @Input()
  newDelegation: Boolean;

  confirmChanges: boolean;
  submitConfirmation: boolean;
  requestConfirmation: RequestConfirmationHelperObject;
  allChanges = new Map<string, Array<string>>();
  updateChangeRequest: boolean;

  constructor(private activateRoute: ActivatedRoute,
              private router: Router,
              private location: Location,
              private titleService: Title,
              private domainService: DomainService) {
  }

  ngOnInit() {
    if (!this.newDelegation) {
      this.activateRoute.params.subscribe(data => {
        this.name = data['name'];
        this.getInputData(history.state);
      });
    }else{
      this.domain.authPolicy ={
        users:[],
        policies:[{
          policyType: 'Control',
          policyThreshold: {
            thresholdType: 'All'
          }
        },{
          policyType: 'Non-Technical',
          policyThreshold: {
            thresholdType: 'All'
          }
        },{
          policyType: 'Technical',
          policyThreshold: {
            thresholdType: 'All'
          }
        },{
          policyType: 'AuthPolicy',
          policyThreshold: {
            thresholdType: 'All'
          }
        }]
      }
    }
  }


  getInputData(data: any) {
    if (data.domain) {
      this.requestMetadata = data.requestMetadata;
      this.domain = data.domain;

      if (data.updateChangeRequest) {
        this.updateChangeRequest = true;
      }
    } else {
      this.domainService.getDomainByID(this.name).subscribe(domain => {
        this.domainService.createContactsIfNull(domain);
        this.domain = domain;
        this.requestMetadata = this.activateRoute.snapshot.data;
        this.requestMetadata.domainName = this.domain.name.toLowerCase().trim() === '.' ? 'root' : this.domain.name;
        const commentInUri = this.activateRoute.snapshot.params?.comment;
        if (commentInUri) {
          this.requestMetadata.comment = decodeURIComponent(commentInUri);
        }

      }, () => {
        console.log('Unable to retrive domain ' + this.name);
      });
    }

  }

  finalizeRequest(helper: CreateRequestHelperObject) {
    this.domainChange = helper.domainChange;
    this.domain = helper.domain;
    this.allChanges = helper.allChanges;
    this.confirmChanges = true;
  }

  reviewDecision(val: any) {
    if (val === CommonStrings.BACK) {
      this.confirmChanges = false;
      this.titleService.setTitle('Review Domain Details');
    } else {
      this.titleService.setTitle('Submission Successful');
      this.requestConfirmation = val;
      this.submitConfirmation = true;

    }
  }

  showTicketNumber() {
    return this.requestMetadata.requestType !== 'DIRECT';
  }

  back() {
    this.location.back();
  }
}
